// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientInfo_root__1deVt","info":"PatientInfo_info__3oe7c"};